import dva from 'dva';
import { Component } from 'react';
import createLoading from 'dva-loading';
import history from '@tmp/history';

let app = null;

export function _onCreate() {
  const plugins = require('umi/_runtimePlugin');
  const runtimeDva = plugins.mergeConfig('dva');
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    ...(window.g_useSSR ? { initialState: window.g_initialData } : {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach(plugin => {
    app.use(plugin);
  });
  
  app.model({ namespace: 'global', ...(require('/app/src/models/global.js').default) });
app.model({ namespace: 'airport', ...(require('/app/src/pages/airport/models/airport.js').default) });
app.model({ namespace: 'airportMotion', ...(require('/app/src/pages/airport/models/airportMotion.js').default) });
app.model({ namespace: 'index', ...(require('/app/src/pages/cip/models/index.js').default) });
app.model({ namespace: 'home', ...(require('/app/src/pages/home/models/home.js').default) });
app.model({ namespace: 'login', ...(require('/app/src/pages/login/models/login.js').default) });
app.model({ namespace: 'lounge', ...(require('/app/src/pages/lounge/models/lounge.js').default) });
app.model({ namespace: 'meal', ...(require('/app/src/pages/meal/models/meal.js').default) });
app.model({ namespace: 'railSetMeal', ...(require('/app/src/pages/railSetMeal/models/railSetMeal.js').default) });
app.model({ namespace: 'record', ...(require('/app/src/pages/record/models/record.js').default) });
app.model({ namespace: 'search', ...(require('/app/src/pages/search/models/search.js').default) });
app.model({ namespace: 'use', ...(require('/app/src/pages/use/models/use.js').default) });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
